<template>
  <!-- 悬浮工具栏（桌面 / 移动端通用） -->
  <header class="toolbar" :class="{ 'is-scrolled': scrolled }">
    <div class="toolbar-inner">
      <div class="brand">
        <span class="brand-dot"></span>
        <span class="brand-name">陈程</span>
        <span class="brand-divider"></span>
        <span class="brand-sub">全栈工程师 · AI 平台 / 智能体</span>
      </div>

      <div class="tool-actions">
        <span class="tool-meta">最后更新于 2026 年 10 月</span>

        <button class="tool-btn" :class="{ 'is-active': layoutOn }" type="button"
          :aria-pressed="layoutOn ? 'true' : 'false'" title="切换单栏 / 双栏布局" @click="Changelayout">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="18" height="18" rx="2"></rect>
            <path d="M9 3v18"></path>
          </svg>
          <span class="tool-btn-text">切换布局</span>
        </button>

        <button class="tool-btn" type="button" title="添加到桌面" @click="getPWA">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="2" y="4" width="20" height="13" rx="2"></rect>
            <path d="M8 21h8"></path>
            <path d="M12 17v4"></path>
          </svg>
          <span class="tool-btn-text">添加到桌面</span>
        </button>

        <button class="tool-btn tool-btn--primary" type="button" :disabled="exporting"
          :aria-label="exporting ? '正在导出 PDF' : '下载 PDF'" :title="exporting ? '正在导出 PDF' : '下载 PDF'"
          @click="getDowoldPDF">
          <span v-if="exporting" class="spinner" aria-hidden="true"></span>
          <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3v12"></path>
            <path d="m7 10 5 5 5-5"></path>
            <path d="M5 21h14"></path>
          </svg>
          <span class="tool-btn-text">{{ exporting ? '导出中…' : '下载 PDF' }}</span>
        </button>
      </div>
    </div>

    <!-- 阅读进度 -->
    <span class="toolbar-progress" :style="{ transform: 'scaleX(' + progress + ')' }" aria-hidden="true"></span>
  </header>
</template>

<script>
import { getPdf } from '@/uilt/getPDF'

export default {
  name: 'Head',
  data() {
    return {
      exporting: false,
      scrolled: false,
      progress: 0,
      _scrollTicking: false
    }
  },
  computed: {
    layoutOn() {
      return !!this.$store.state.changeLayoutClass
    }
  },
  methods: {
    /* ---------------- PDF 导出 ---------------- */
    async getDowoldPDF() {
      if (this.exporting) return
      const target = document.getElementById('contentPDF')
      if (!target) return

      this.exporting = true
      // 关闭入场动画，并让滚动隐藏的内容强制可见，避免截图出现空白
      this.$store.state.animationClass = false
      document.body.classList.add('exporting-pdf')

      try {
        await this.outPutPdfFn('陈程 - 全栈工程师', target, 'item')
        this.$message({ type: 'success', message: 'PDF 导出成功' })
      } catch (e) {
        console.error('PDF 导出失败', e)
        this.$message({ type: 'error', message: 'PDF 导出失败，请重试' })
      } finally {
        document.body.classList.remove('exporting-pdf')
        this.$store.state.animationClass = true
        this.exporting = false
      }
    },

    outPutPdfFn(title, target, itemClass) {
      const A4_WIDTH = 592.28
      const A4_HEIGHT = 841.89

      return this.$nextTick().then(() => {
        const pageHeight = (target.scrollWidth / A4_WIDTH) * A4_HEIGHT
        const labelList = document.getElementsByClassName(itemClass)
        const placeholders = []

        // 当内容超出 A4 高度时，插入空白占位把该块挤到下一页，避免卡片被切断
        for (let i = 0; i < labelList.length; i++) {
          const node = labelList[i]
          const bottom = node.offsetTop + node.offsetHeight
          const multiple = Math.ceil(bottom / pageHeight)

          if (this.isSplit(labelList, i, multiple * pageHeight)) {
            const parent = node.parentNode
            const spacer = document.createElement('div')
            spacer.className = 'emptyDiv'
            spacer.id = `emptyDiv-${i}`
            spacer.style.background = '#ffffff'
            spacer.style.height = multiple * pageHeight - bottom + 30 + 'px'
            spacer.style.width = '100%'
            parent.insertBefore(spacer, node.nextSibling)
            placeholders.push(spacer)
          }
        }

        return getPdf(title, target, 'emptyDiv').finally(() => {
          placeholders.forEach((el) => {
            if (el.parentNode) el.parentNode.removeChild(el)
          })
        })
      })
    },

    isSplit(nodes, index, pageHeight) {
      return (
        nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight &&
        nodes[index + 1] &&
        nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
      )
    },

    /* ---------------- 其它交互 ---------------- */
    Changelayout() {
      this.$store.state.changeLayoutClass = !this.$store.state.changeLayoutClass
    },

    /* ---------------- 滚动进度 ---------------- */
    updateScroll() {
      const doc = document.documentElement
      const scrollTop = window.pageYOffset || doc.scrollTop || document.body.scrollTop || 0
      const max = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight
      this.progress = max > 0 ? Math.min(1, Math.max(0, scrollTop / max)) : 0
      this.scrolled = scrollTop > 8
    },

    handleScroll() {
      if (this._scrollTicking) return
      this._scrollTicking = true
      requestAnimationFrame(() => {
        this.updateScroll()
        this._scrollTicking = false
      })
    },

    getPWA() {
      const deferredPrompt = this.$store.state.deferredPrompt
      if (!deferredPrompt) {
        this.$message({
          type: 'info',
          message: '当前浏览器暂不支持一键安装，可使用浏览器菜单「添加到主屏幕」'
        })
        return
      }

      deferredPrompt.prompt()
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          this.$message({ type: 'success', message: '已添加到桌面' })
        }
        this.$store.state.deferredPrompt = null
      })
    }
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.$store.state.deferredPrompt = e
    })

    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.handleScroll)
    this.updateScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  }
}
</script>

<style scoped>
.toolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.74);
  backdrop-filter: saturate(180%) blur(14px);
  -webkit-backdrop-filter: saturate(180%) blur(14px);
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 10px 30px -24px rgba(15, 23, 42, 0.5);
  animation: toolbarIn 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.toolbar.is-scrolled {
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 16px 36px -26px rgba(15, 23, 42, 0.75);
}

/* 阅读进度线 */
.toolbar-progress {
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  transform-origin: 0 50%;
  background-image: linear-gradient(90deg, #2563eb, #7c3aed, #06b6d4);
  transition: transform 0.12s linear;
  will-change: transform;
}

.toolbar-inner {
  width: 1200px;
  max-width: calc(100% - 32px);
  height: 64px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.brand-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #7c3aed);
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
  animation: pulseDot 2.6s ease-in-out infinite;
}

.brand-name {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 2px;
}

.brand-divider {
  width: 1px;
  height: 14px;
  background: #dbe3f0;
}

.brand-sub {
  font-size: 12.5px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tool-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tool-meta {
  margin-right: 6px;
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
}

.tool-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.22s ease, border-color 0.22s ease, background 0.22s ease, transform 0.22s ease,
    box-shadow 0.22s ease;
}

.tool-btn svg {
  flex: 0 0 auto;
  opacity: 0.85;
}

.tool-btn:hover {
  color: #1d4ed8;
  border-color: #c7dbff;
  background: #f5f9ff;
  transform: translateY(-1px);
  box-shadow: 0 10px 20px -16px rgba(37, 99, 235, 0.9);
}

.tool-btn:active {
  transform: translateY(0);
}

.tool-btn.is-active {
  color: #1d4ed8;
  border-color: #bfd4ff;
  background: #eef4ff;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.12);
}

.tool-btn--primary {
  border-color: transparent;
  color: #fff;
  background-image: linear-gradient(135deg, #2563eb, #6d28d9);
  box-shadow: 0 12px 24px -14px rgba(37, 99, 235, 0.9);
}

.tool-btn--primary:hover {
  color: #fff;
  background-image: linear-gradient(135deg, #1d4ed8, #5b21b6);
}

.tool-btn--primary:disabled {
  cursor: progress;
  opacity: 0.75;
  transform: none;
}

.spinner {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulseDot {
  0%,
  100% {
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(37, 99, 235, 0.06);
  }
}

@keyframes toolbarIn {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media screen and (max-width: 1100px) {
  .tool-meta {
    display: none;
  }
}

@media screen and (max-width: 900px) {
  .brand-sub,
  .brand-divider {
    display: none;
  }
}

@media screen and (max-width: 720px) {
  .toolbar-inner {
    height: 56px;
    max-width: calc(100% - 24px);
    gap: 10px;
  }

  .brand-name {
    font-size: 14px;
    letter-spacing: 1px;
  }

  .brand-dot {
    width: 8px;
    height: 8px;
  }

  .tool-actions {
    gap: 6px;
  }

  .tool-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
  }

  .tool-btn-text {
    display: none;
  }

  .tool-btn--primary {
    width: auto;
    padding: 0 12px;
  }

  .tool-btn--primary .tool-btn-text {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toolbar,
  .brand-dot {
    animation: none;
  }

  .toolbar-progress {
    transition: none;
  }
}
</style>
